import BaseProcessor from './BaseProcessor';
import store from '@/store';
import PaymentNotificator from '@/services/PaymentNotificator';
import PaymentStatus from '@/models/PaymentStatus';
import Swal from 'sweetalert2';
import vars from '@/config/vars';
import timeHelper from '@/helpers/timeHelper';
import { logException } from '@/helpers/cieloLogger';

export default class PixProcessor extends BaseProcessor {
    constructor(multiLanguage) {
        super(multiLanguage);
    }

    /**
     * Processa a transação pix
     */
    async ProcessTransaction() {
        super.BuildContract({
            Card: {
                ...store.getters['billingAddress/getSubmitModel']
            }
        });

        let response = await super.SendTransactionRequest();

        if (super.ResponseIsSuccess(response) == false) return;
        
        store.commit('pixPayment/pixSuccessResponse', response);
        
        if (!response.Data.QrCodeBase64Image)
        {
            showQrCodeErrorMessage(this.multiLanguage);
            return;
        }

        store.dispatch('preorder/setTransactionAsFinalized');
        store.dispatch('pipelineV2/pushTo', 'PixFinalizeScreen');
        await listenToRealTimeNotification(response);
    }
}

function showQrCodeErrorMessage(multiLanguage) {
    Swal.fire({
        type: 'error',
        title: 'Oppsss!',
        text: multiLanguage.get('qrCodeGenerationError')
    })
        .then(() => document.location.reload());
}

async function listenToRealTimeNotification(transactionResponse) {
    try {
        if (vars.USE_SIMULATED_MODE)
            return SendToSuccessPage(transactionResponse);

        PaymentNotificator.OnStatusChange((status) => {
            if (status == PaymentStatus.PAID)
                SendToSuccessPage(transactionResponse);
    
            PaymentNotificator.CloseConnection();
        });
        
        await PaymentNotificator.StartConnection(transactionResponse.Data.OrderId);

        setTimeout(
            () => PaymentNotificator.CloseConnection(), 
            timeHelper.minutesToMs(vars.MINUTES_TO_CLOSE_HUB_CONNECTION));

    } catch (error) {
        logException(error);
        PaymentNotificator.CloseConnection();
    }
}

function SendToSuccessPage(transactionResponse) {
    
    if (transactionResponse.Data.Redirect && transactionResponse.Data.Url)
        return window.location.href = transactionResponse.Data.Url;

    store.dispatch('pipelineV2/pushToOrderStatus', transactionResponse.Data.OrderId);
}